import { render, staticRenderFns } from "./PagedMsgTable.vue?vue&type=template&id=a8f4dc62&scoped=true&"
import script from "./PagedMsgTable.vue?vue&type=script&lang=js&"
export * from "./PagedMsgTable.vue?vue&type=script&lang=js&"
import style0 from "./PagedMsgTable.vue?vue&type=style&index=0&id=a8f4dc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f4dc62",
  null
  
)

export default component.exports